import { createReducer, on } from '@ngrx/store';
import {
  deleteDataModel,
  getDataModel,
  saveDataModel,
  updateDataModel,
  getComplexTypeTables,
  setComplexTypeTables,
  setDataModel,
  saveAppDatamodelBatch,
  getAllDataModelTables,
  setAllDataModelTables,
  deleteTableData,
  deleteDatamodelData,
  updateDataModelTreeOrder,
  saveDatamodelDataSuccess,
  setTreeOrder,
  saveDatamodelDataFailure,
  saveDatamodelTableFailure,
  saveDatamodelTableSuccess,
  saveTableFldData,
  saveDatamodelTreeSuccess,
  saveDatamodelTreeFailure,
  updateForeignKey,
  getForeignKey,
  setForeignKey,
  setAllTables,
  deleteForeignKey,
  deletedFKId,
  deleteFKFailure,
  deleteFKSuccess,
  updateFKFailure,
  updateFKSuccess,
  setAllForeignKeys,
  getAllForeignKeys,
  setLookUpTables
} from '../actions/datamodel.actions';

export interface DataModelState {
  data: any;
  tableInfo: any;
  initialProperties: any;
  foreignKeyTbl: any;
}

export const initialState: DataModelState = {
  data: {},
  tableInfo: {},
  initialProperties: {},
  foreignKeyTbl: []
};

export const datamodelReducer = createReducer(
  initialState,
  on(getAllDataModelTables, (state, { datamodelApiConstants }) => ({
    ...state,
    ...{ datamodelApiConstants }
  })),
  on(setAllDataModelTables, (state, { allDataModelTables }) => ({
    ...state,
    ...{ allDataModelTables }
  })),
  on(getDataModel, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setComplexTypeTables, (state, { complexTypeTables }) => ({
    ...state,
    ...{ complexTypeTables }
  })),
  on(getComplexTypeTables, (state, { datamodelApiConstants, params }) => ({
    ...state,
    ...{ datamodelApiConstants },
    ...{ params }
  })),
  on(setLookUpTables, (state, { lookUpTables }) => {
    return {
      ...state,
      ...{ lookUpTables }
    };
  }),

  on(saveDataModel, (state, { apiConstants, datamodelData }) => ({
    ...state,
    ...apiConstants,
    ...datamodelData
  })),
  on(saveTableFldData, (state, { datamodelApiConstants, tableFldData }) => ({
    ...state,
    ...datamodelApiConstants,
    ...tableFldData
  })),
  on(updateDataModel, (state, { datamodelApiConstants, datamodelData }) => {
    return {
      ...state,
      ...datamodelApiConstants,
      ...datamodelData
    };
  }),
  on(deleteDataModel, (state, { datamodelId }) => {
    return {
      ...state,
      datamodelId
    };
  }),
  on(setDataModel, (state, { datamodelData }) => {
    //console.log(datamodelData)
    return {
      ...state,
      ...{
        data: datamodelData.data,
        tableInfo: datamodelData.tableInfo,
        initialProperties: datamodelData.initialProperties
      }
    };
  }),
  on(saveAppDatamodelBatch, (state, { batchApiConstants, data }) => {
    return {
      ...state,
      ...batchApiConstants,
      ...data
    };
  }),
  on(updateDataModelTreeOrder, (state, { datamodelApiConstants, orderInfo }) => {
    return {
      ...state,
      ...datamodelApiConstants,
      ...orderInfo
    };
  }),
  on(deleteDatamodelData, (state, { fieldId }) => {
    return {
      ...state,
      fieldId
    };
  }),
  on(deleteTableData, (state, { tableId }) => {
    return {
      ...state,
      tableId
    };
  }),
  on(saveDatamodelDataSuccess, (state, { results }) => {
    return {
      ...state,
      results
    };
  }),
  on(saveDatamodelDataFailure, (state, { error }) => {
    return {
      ...state,
      error
    };
  }),
  on(setTreeOrder, (state, { treeOrder }) => {
    return {
      ...state,
      ...{ treeOrder }
    };
  }),
  on(saveDatamodelTableFailure, (state, { tableError }) => {
    return {
      ...state,
      tableError
    };
  }),
  on(saveDatamodelTableSuccess, (state, { tableResults }) => {
    return {
      ...state,
      tableResults
    };
  }),
  on(saveDatamodelTreeSuccess, (state, { treeResults }) => {
    return {
      ...state,
      treeResults
    };
  }),
  on(saveDatamodelTreeFailure, (state, { treeError }) => {
    return {
      ...state,
      treeError
    };
  }),
  on(getForeignKey, (state, { fkapiConstants, data }) => ({
    ...state,
    ...{ fkapiConstants },
    ...{ data }
  })),
  on(updateForeignKey, (state, { updfkapiConstants, foreignKeyData }) => ({
    ...state,
    ...{ updfkapiConstants },
    ...{ foreignKeyData }
  })),
  on(setForeignKey, (state, { foreignKeyTbl }) => {
    return {
      ...state,
      ...{ foreignKeyTbl }
    };
  }),
  on(setAllTables, (state, { allTables }) => {
    return {
      ...state,
      ...{ allTables }
    };
  }),
  on(deleteForeignKey, (state, data) => {
    return ({
      ...state,
      data
    })
  }),
  on(deletedFKId, (state, { fkId }) => {
    const allfks = state?.foreignKeyTbl;
    const filteredData = allfks.filter((fk: { sid: string }) => fk.sid !== fkId);
    return {
      ...state,
      foreignKeyTbl: filteredData
    };
  }),
  on(deleteFKFailure, (state, { fkDelFailure }) => {
    return {
      ...state,
      ...{ fkDelFailure }
    };
  }),
  on(updateFKFailure, (state, { fKSaveFailure }) => {
    return {
      ...state,
      ...{ fKSaveFailure }
    };
  }),
  on(updateFKSuccess, (state, { fKSaveSuccess }) => {
    return {
      ...state,
      ...{ fKSaveSuccess }
    };
  }),
  on(deleteFKSuccess, (state, { fkDelSuccess }) => {
    return {
      ...state,
      ...{ fkDelSuccess }
    };
  }),
  on(getAllForeignKeys, (state, { fkallapiConstants }) => ({
    ...state,
    ...{ fkallapiConstants }
  })),
  on(setAllForeignKeys, (state, { allForeignKeys }) => {
    return {
      ...state,
      ...{ allForeignKeys }
    };
  })
);
